module.exports = __webpack_public_path__ + "static/regulatorafter-e5cbda4bcb59045c60926dc1224a56e8.jpg";